<app-table-generator
    [tableInput]="tableInput"
    [widgetRef]="widgetRef"
></app-table-generator>
